import { Injectable } from '@angular/core';
import {Subject} from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class HeaderService {

  private _header: string = '';
  headerChanged: Subject<string> = new Subject();

  constructor() { }

  setHeader(header: string)
  {
    this._header = header;
    this.headerChanged.next(this._header);
  }
}
